import { parseISOString, toCurrency, toFullDateTime } from "utils/string-localization-helper"

export enum AdHocDiscountType {
    EXACT_VALUE,
    PERCENT
}

export enum Commission {
    CUSTOM,
    DEFAULT
}

export type SalesAndComissionDTO = {
    adhocDiscount: number
    adhocDiscountType: AdHocDiscountType
    clientEmail: string
    clientName: string
    commission: Commission
    commissionAmount: number
    commissionPercent: number
    couponCode: string
    orderDate: string
    fullyPaid: boolean
    itemName: string
    itemType: string
    locations: string[]
    membershipName: string
    notes: string
    soldBy: string
    taxOverride: number
    totalAmount: number
}

export type SalesAndComission = SalesAndComissionDTO & {
    commission_amount: string
    total_amount: string
    location: string
}

export function mapSalesReport(dto: SalesAndComissionDTO): SalesAndComission {
    const orderDate = toFullDateTime(parseISOString(dto.orderDate))
    const commission_amount = toCurrency(dto.commissionAmount)
    const total_amount = toCurrency(dto.totalAmount)
    const location = dto.locations && dto.locations.length ? dto.locations.join(',') : 'All'
    return {
        ...dto,
        orderDate,
        commission_amount,
        total_amount,
        location
    } as SalesAndComission
}

